import { User, MapPin, Users, Clock, Phone, FileText, Contact, Heart, Briefcase, GraduationCap, FileCheck, Users2 } from 'lucide-react';

// 基础表单页面配置（所有签证类型都需要）
export const baseFormPages = [
  { id: 'personal_1', title: '个人信息 1', icon: User },
  { id: 'personal_2', title: '个人信息 2', icon: User },
  { id: 'travel', title: '旅行信息', icon: MapPin },
  { id: 'travel_companions_info', title: '旅行伙伴信息', icon: Users },
  { id: 'previous_US_travel_info', title: '美国旅行历史', icon: Clock },
  { id: 'address_phone', title: '地址电话', icon: Phone },
  { id: 'passport_visa', title: '护照签证', icon: FileText },
  { id: 'us_contact', title: '美国联系人', icon: Contact },
  { id: 'family_info', title: '家庭信息', icon: Heart },
  { id: 'work_education', title: '工作教育 1', icon: Briefcase },
  { id: 'work_education2', title: '工作教育 2', icon: Briefcase },
  { id: 'work_education3', title: '特殊信息和背景调查', icon: GraduationCap },
  { id: 'part1', title: '补充信息 1', icon: FileCheck },
  { id: 'part2', title: '补充信息 2', icon: FileCheck },
  { id: 'part3', title: '补充信息 3', icon: FileCheck },
  { id: 'part4', title: '补充信息 4', icon: FileCheck },
  { id: 'part5', title: '补充信息 5', icon: FileCheck },
];

// 签证类型特定的表单页面
export const visaSpecificPages = {
  F: [
    { id: 'f1_additional_contacts', title: 'F1额外联系人', icon: Users2 },
    { id: 'f1_school_info', title: 'F1学校信息', icon: GraduationCap }
  ],
  F2: [
    { id: 'f2_sevis_info', title: 'F2 SEVIS信息', icon: FileText }
  ],
  // 可以添加其他签证类型的特定页面
  // M: [...],
  // J: [...],
};

// 获取当前签证类型的所有表单页面
export const getFormPagesForVisaType = (visaType) => {
  const specificPages = visaSpecificPages[visaType] || [];
  return [...baseFormPages, ...specificPages];
};

// 默认表单页面（向后兼容）
export const formPages = baseFormPages; 